import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
export interface ProjectTypeMasterState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allProjectTypeMaster: [] | null | any;
}
const initialState: ProjectTypeMasterState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allProjectTypeMaster: null
};
export const projectTypeMasterSlice = createSlice({
  name: 'projectTypeMaster',
  initialState,
  reducers: {
    setAllProjectTypeMaster: (state, action) => {
      state.allProjectTypeMaster = action.payload.data;
    },
    setProjectTypeMaster: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllProjectTypeMasterBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});
// Action creators are generated for each case reducer function
export const { setAllProjectTypeMaster, setProjectTypeMaster, setAllProjectTypeMasterBySearch,reset } = projectTypeMasterSlice.actions;
export const allProjectTypeMasterDetails = (state: RootState) => state.projectTypeMaster.allProjectTypeMaster;
export const getAllProjectTypeMasterDetails = (state: RootState) => state.projectTypeMaster.data;
export const getProjectTypeMasterTotalRecords=(state:RootState)=>state.projectTypeMaster.totalRecords;
export const getAllProjectTypeMasterBySearch = (state: RootState) => state.projectTypeMaster.data;
export default projectTypeMasterSlice.reducer;